import React from "react";
import SigmaLogo from "src/assets/images/S1GMA_Logo.svg"
import Image from "src/assets/images/BG-Tile.svg"

export const AuthenticationWrawper = ({ children }) => {
  return (
    <div
      className="vh-100 vw-100 main-div row m-0"
      style={{ backgroundImage: `url(${Image})` }}
    >
      <div className="col-md-6 d-flex align-items-center justify-content-center justify-content-md-center">
        <div className="logoWrapper">
          <img className="muztransLogo" src={SigmaLogo} width={"100%"} height={"100%"} alt="Muztrans logo"></img>
        </div>
      </div>

      <div className="col-md-6 d-flex justify-content-center align-items-start align-items-md-center">
        <div className="card responsiveCard">
          <div className="card-body" style={{ zIndex: 1 }}>
            <div className="d-flex flex-column justify-content-center align-items-center">
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
